<template>
  <div class="breadcrumb-box f-df f-jcsb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbList"
        :key="index"
        :to="{ path: item.path || '' }">
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="login-out-box f-df f-ai">
      <figure></figure>
      <figcaption>{{ ($store.state.userInfo.userName || $store.state.userInfo.account) + '，'}}</figcaption>
      <span class="color-blue f-csp" @click="loginOut">退出</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbList: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    // 退出
    loginOut() {
      this.$router.push({
        path: '/login'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.breadcrumb-box{
  position: fixed;
  top: 0;
  width: calc(~'100% - 223px');
  background-color: @wrap-bg;
  padding: 15px 15px 15px 0;
  z-index: 999;
}
</style>
